export default __webpack_public_path__ + "static/media/anti-slip_brown.d45e4201.webp";